import React from "react";

// Renders markdown images (![alt](src)) with consistent spacing and
// treats the alt text as a visible caption underneath, since plain
// markdown has no native caption syntax.
const MdxImage = (props) => (
  <span className="block my-10">
    <img
      {...props}
      className="w-full h-auto"
      loading="lazy"
    />
    {props.alt && (
      <span className="block text-center text-[13px] text-[#888888] font-light mt-3">
        {props.alt}
      </span>
    )}
  </span>
);

// Opens external links in a new tab automatically; internal links
// (starting with "/") behave normally. Styling matches the red
// accent already used for links elsewhere on the site.
const MdxLink = ({ href = "", children, ...rest }) => {
  const isExternal = /^https?:\/\//.test(href);
  return (
    <a
      href={href}
      className="text-[#de2110] underline"
      {...(isExternal ? { target: "_blank", rel: "noreferrer" } : {})}
      {...rest}
    >
      {children}
    </a>
  );
};

const mdxComponents = {
  img: MdxImage,
  a: MdxLink,
};

export default mdxComponents;
